@import ../../../styles/helpers

.container
    width: 100%
    height: 100%
    background-color: $dark_contrast
    border-radius: $border_radius_big
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    gap: $context_margin
    padding-bottom: 150px
    h1
        +body-title
    p
        +body